import {
    list,
    loadRequest,
    text as sendText,
    upload
} from "src/repositories/request.repository";

export const LOAD_REQUESTS_REQUEST = "LOAD_REQUESTS_REQUEST";
export const LOAD_REQUESTS_SUCCESS = "LOAD_REQUESTS_SUCCESS";
export const LOAD_REQUESTS_ERROR = "LOAD_REQUESTS_ERROR";

export const LOAD_REQUEST_REQUEST = "LOAD_REQUEST_REQUEST";
export const LOAD_REQUEST_SUCCESS = "LOAD_REQUEST_SUCCESS";
export const LOAD_REQUEST_ERROR = "LOAD_REQUEST_ERROR";

// button to 'submit'
export const SEND_TEXT_REQUEST = "SEND_TEXT_REQUEST";
export const SEND_TEXT_SUCCESS = "SEND_TEXT_SUCCESS";
export const SEND_TEXT_ERROR = "SEND_TEXT_ERROR";

export const loadRequests = params => dispatch => {
    dispatch({ type: LOAD_REQUESTS_REQUEST, payload: null });

    return list(params)
        .then(res =>
            dispatch({ type: LOAD_REQUESTS_SUCCESS, payload: res.data })
        )
        .catch(e => {
            dispatch({ type: LOAD_REQUESTS_ERROR, payload: e });
            throw e;
        });
};

export const findRequest = pkRequest => dispatch => {
    dispatch({ type: LOAD_REQUEST_REQUEST, payload: null });
    return loadRequest(pkRequest)
        .then(res =>
            dispatch({
                type: LOAD_REQUEST_SUCCESS,
                payload: res.data
            })
        )
        .catch(e => {
            dispatch({ type: LOAD_REQUEST_ERROR, payload: e });
            throw e;
        });
};

export const sendInteraction = (id, text) => dispatch => {
    dispatch({ type: SEND_TEXT_REQUEST, payload: null });

    return sendText(id, text)
        .then(res => {
            dispatch({ type: SEND_TEXT_SUCCESS, payload: res.data });
        })
        .catch(e => {
            dispatch({ type: SEND_TEXT_ERROR, payload: e });
            throw e;
        });
};

export const sendFiles = (id, files) => dispatch => {
    dispatch({ type: SEND_TEXT_REQUEST, payload: null });

    return upload(id, files)
        .then(res => true)
        .catch(e => {
            throw e;
        });
};

